import { useNavigate } from "react-router";
import { Button, LinkButton } from "@/ui/Button";
import { Sheet } from "@/ui/Sheet";
import { Display, Label, Body } from "@/ui/Text";
import type { WallCopy } from "./paywall-copy";

interface PaywallProps {
  readonly copy: WallCopy | null;
  readonly onClose: () => void;
}

/**
 * The wall. Shown as a sheet over whatever the person was doing; the one
 * action goes to the plan page, where subscribing actually happens.
 */
export function Paywall({ copy, onClose }: PaywallProps) {
  const navigate = useNavigate();
  return (
    <Sheet open={copy !== null} onClose={onClose} label="Subscribe to Antar">
      {copy && (
        <>
          <Label>{copy.eyebrow}</Label>
          <Display size="md" as="h2" className="mt-2">
            {copy.title}
          </Display>
          <Body className="mt-3 text-mid">{copy.body}</Body>
          <div className="mt-6 flex flex-col gap-2">
            <Button
              label="See the plan"
              onClick={() => {
                onClose();
                navigate("/you/plan");
              }}
            />
            <LinkButton label="Not now" onClick={onClose} />
          </div>
        </>
      )}
    </Sheet>
  );
}
